
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ingestion",
      function () {
        return require("private-next-pages/ingestion.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ingestion"])
      });
    }
  